<template>
  <button type="button" :aria-label="label" class="flex cursor-pointer items-center justify-center rounded-full transition-all duration-150" :class="[sizeClasses, toneClasses]">
    <slot />
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    label?: string
    size?: 'sm' | 'md'
    /** `outline` is the bordered surface button; `filled` the tinted close-button style; `ghost` is borderless, tinted on hover only. */
    tone?: 'outline' | 'filled' | 'ghost'
  }>(),
  { label: undefined, size: 'sm', tone: 'outline' },
)

const sizeClasses = computed(() => ({ sm: 'h-8 w-8', md: 'h-9.5 w-9.5' })[props.size])

const toneClasses = computed(
  () =>
    ({
      outline: 'border-hairline bg-surface text-ink hover:bg-grey-100 border text-[14px] dark:hover:bg-white/5',
      filled: 'bg-grey-200 text-grey-500 hover:bg-grey-300 dark:bg-white/10 dark:hover:bg-white/20',
      ghost: 'text-muted hover:bg-surface-subtle hover:text-ink',
    })[props.tone],
)
</script>
